import { AppShell } from "@monorepo/app-shell";

import { routes } from "./routes";

const App = () => <AppShell routes={routes} />;

export default App;
